import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueScrollTo from 'vue-scrollto'
import VueGtm from 'vue-gtm'

Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  if (to.meta.description) {
    document.querySelector("meta[name='description']").setAttribute('content', to.meta.description)
  }
  if (to.meta.robots) {
    document.querySelector("meta[name='robots']").setAttribute('content', to.meta.robots)
  }
  next()
})

Vue.directive('scroll', {
  inserted: function (el, binding) {
    let f = function (evt) {
      if (binding.value(evt, el)) {
        window.removeEventListener('scroll', f)
      }
    }
    window.addEventListener('scroll', f)
  }
})

Vue.use(VueScrollTo, {
  easing: 'ease'
})

Vue.use(VueGtm, {
  id: process.env.VUE_APP_GTM_ID,
  enabled: true,
  debug: false,
  loadScript: true,
  vueRouter: router
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
